module.exports = __webpack_public_path__ + "img/05.40d7a00c.jpg";